/* ==========================================================================
   New Home Barn Megamenu - See admin notes for more details.
   ========================================================================== */
(function () {
  var OPEN_DELAY = 150;
  var CLOSE_DELAY = 220;

  function initMegamenu(root) {
    if (root.dataset.hbInitialised === 'true') return;
    root.dataset.hbInitialised = 'true';

    var details = root.closest('details');
    var summary = details ? details.querySelector(':scope > summary') : null;
    var col3 = root.querySelector('[data-hb-col3]');
    var topLinks = root.querySelectorAll('[data-hb-section-trigger]');
    var sectionPanels = root.querySelectorAll('[data-hb-section-panel]');
    var sectionImages = root.querySelectorAll('[data-hb-images]');
    var col3Groups = col3 ? col3.querySelectorAll('[data-hb-col3-for]') : [];

    var openTimer = null;
    var closeTimer = null;
    var panelOpen = false;
    var activeSection = 'furniture';

    function retriggerAnimation(el, className) {
      el.classList.remove(className);
      void el.offsetWidth; // force reflow so the CSS animation restarts
      el.classList.add(className);
    }

    function clearCol2State(panel) {
      panel.classList.remove('is-differentiated');
      panel.querySelectorAll('.is-highlighted, .is-hovered, .show-underline').forEach(function (el) {
        el.classList.remove('is-highlighted', 'is-hovered', 'show-underline');
      });
    }

    function hideAllCol3() {
      col3Groups.forEach(function (g) { g.classList.remove('is-active'); });
      if (col3) col3.classList.remove('is-differentiated');
    }

    // ---- _openPanel / _switchSection equivalent ----
    function setSection(key, silent) {
      activeSection = key;
      topLinks.forEach(function (l) {
        l.classList.toggle('is-active', l.dataset.hbSectionTrigger === key);
      });
      sectionPanels.forEach(function (p) {
        var match = p.dataset.hbSectionPanel === key;
        p.classList.toggle('is-active', match);
        if (match) clearCol2State(p);
      });
      sectionImages.forEach(function (img) {
        var match = img.dataset.hbImages === key;
        if (match) {
          if (silent) { img.classList.add('is-active'); } else { retriggerAnimation(img, 'is-active'); }
        } else {
          img.classList.remove('is-active');
        }
      });
      hideAllCol3();
    }

    function openPanel(key) {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () {
        setSection(key);
        panelOpen = true;
        if (details) details.setAttribute('open', '');
      }, OPEN_DELAY);
    }

    function switchSection(key) {
      clearTimeout(openTimer);
      openTimer = setTimeout(function () {
        setSection(key);
      }, OPEN_DELAY);
    }

    function keepOpen() {
      clearTimeout(closeTimer);
    }

    function startClose() {
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () {
        panelOpen = false;
        if (details) details.removeAttribute('open');
      }, CLOSE_DELAY);
    }

    // ---- Open/close triggers ----
    if (summary) {
      summary.addEventListener('mouseenter', function () { openPanel(activeSection); });
    }
    if (details) {
      details.addEventListener('mouseleave', startClose);
    }
    root.addEventListener('mouseenter', keepOpen);

    topLinks.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        var key = link.dataset.hbSectionTrigger;
        if (panelOpen) {
          switchSection(key);
        } else {
          openPanel(key);
        }
      });
    });

    // ---- Column 2: hover highlight (sticky), underline, chevron, Column 3 reveal ----
    sectionPanels.forEach(function (panel) {
      var items = panel.querySelectorAll('[data-hb-mid]');

      items.forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          var key = item.dataset.hbKey;
          panel.classList.add('is-differentiated');
          items.forEach(function (i) {
            i.classList.remove('is-hovered', 'show-underline');
            // is-highlighted is sticky - only the newly hovered item takes it
            i.classList.remove('is-highlighted');
          });
          item.classList.add('is-highlighted', 'is-hovered', 'show-underline');

          if (item.dataset.hbHasChildren === 'true' && key !== 'all') {
            showCol3For(key);
          } else {
            hideAllCol3();
          }
        });
      });

      panel.addEventListener('mouseleave', function () {
        // Real hover state clears; the sticky "last selected" (is-highlighted)
        // and Column 3 content both persist until a different item is hovered
        // or the section/group switches - matches activeCol2Key persisting
        // after hoveredCol2Key resets to null in the approved prototype.
        items.forEach(function (i) {
          i.classList.remove('is-hovered', 'show-underline');
        });
      });
    });

    function showCol3For(key) {
      var matched = null;
      col3Groups.forEach(function (g) {
        var isMatch = g.dataset.hbCol3For === key;
        if (isMatch) matched = g;
      });
      if (!matched) { hideAllCol3(); return; }
      col3Groups.forEach(function (g) { g.classList.remove('is-active'); });
      retriggerAnimation(matched, 'is-active');
      if (col3) {
        col3.classList.add('is-differentiated');
        col3.querySelectorAll('.hb-megamenu__col3-link').forEach(function (l) {
          l.classList.remove('is-hovered');
        });
      }
    }

    if (col3) {
      col3.addEventListener('mouseover', function (e) {
        var link = e.target.closest('.hb-megamenu__col3-link');
        if (!link) return;
        col3.querySelectorAll('.hb-megamenu__col3-link').forEach(function (l) {
          l.classList.remove('is-hovered');
        });
        link.classList.add('is-hovered');
      });
      col3.addEventListener('mouseleave', function () {
        col3.querySelectorAll('.hb-megamenu__col3-link').forEach(function (l) {
          l.classList.remove('is-hovered');
        });
      });
    }

    // ---- Accordion (Furniture, Antiques & Vintage only) - single-open ----
    sectionPanels.forEach(function (panel) {
      var toggles = panel.querySelectorAll('[data-hb-group-toggle]');
      if (!toggles.length) return;

      toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          var key = toggle.dataset.hbGroupKey;
          var willOpen = !toggle.classList.contains('is-open');

          toggles.forEach(function (t) { t.classList.remove('is-open'); });
          panel.querySelectorAll('[data-hb-group-items]').forEach(function (g) {
            g.classList.remove('is-open');
          });

          if (willOpen) {
            toggle.classList.add('is-open');
            var itemsBlock = panel.querySelector('[data-hb-group-items="' + key + '"]');
            if (itemsBlock) itemsBlock.classList.add('is-open');
          }

          // Matches _toggleGroup: clears col2/col3 hover+sticky state on any toggle.
          clearCol2State(panel);
          hideAllCol3();
        });
      });
    });

    // Default state on load - silent, since the server-rendered HTML
    // already has Furniture marked active; no need to restart its fade-in.
    setSection('furniture', true);
  }

  function initAll() {
    document.querySelectorAll('[data-hb-megamenu]').forEach(initMegamenu);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-hb-megamenu]').forEach(function (el) {
      el.dataset.hbInitialised = 'false';
      initMegamenu(el);
    });
  });
})();
